// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2l_dR","inputWrap":"CustomTip_inputWrap__2etml"};